import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useHospitalData } from "@/contexts/HospitalDataProvider";
import { recurringShiftsPath } from "@/utils/recurringShiftsRoutes";
import {
	SCHEDULE_TEMPLATE_LOCATIONS_TAB,
	type ScheduleTemplatePageTab,
	ScheduleTemplateTabs,
	useScheduleTemplateTab,
} from "../MasterSchedule/ScheduleTemplateTabs";

/** Locations is the selected tab and already open, so choosing it again has nothing to do. */
const stayOnLocations = (): void => undefined;

/**
 * The Schedule Template's tab strip on the Locations page, Locations selected. Choosing a template layout persists
 * it (as the Schedule Template's own strip does) and goes back to the Schedule Template, which opens on it.
 */
export const LocationsSectionTabs: FC = () => {
	const navigate = useNavigate();
	const { chosenDepartment } = useHospitalData();
	const { setSelectedTab, isConsecutiveEnabled, isCoverageEnabled } = useScheduleTemplateTab();

	const openTemplateTab = (tab: ScheduleTemplatePageTab): void => {
		setSelectedTab(tab);
		navigate(recurringShiftsPath(chosenDepartment.department_id));
	};

	return (
		<ScheduleTemplateTabs
			selectedTab={SCHEDULE_TEMPLATE_LOCATIONS_TAB}
			onChange={openTemplateTab}
			onOpenLocations={stayOnLocations}
			isConsecutiveEnabled={isConsecutiveEnabled}
			isCoverageEnabled={isCoverageEnabled}
		/>
	);
};
